// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout--DxHCa {
  min-height: 100%;
  place-content: start;
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/layout.module.less"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,oBAAA;AACF","sourcesContent":[".layout {\n  min-height: 100%;\n  place-content: start;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": `layout--DxHCa`
};
export default ___CSS_LOADER_EXPORT___;
